module.exports = __webpack_public_path__ + "img/resm.5e7f4708.png";